/* =======================================================
   Quick Cart — close helper
   - Closes when:
     a) anything with [data-quick-cart-close] is clicked, OR
     b) the empty-state CTA from the snippet is clicked
   - Prevents navigation on those anchors
   ======================================================= */
(() => {
  const WRAP_SEL = '.quick-cart__wrapper';
  const ROOT_SEL = '.quick-cart';
  // Matches both our custom data attribute and the snippet-based CTA
  const CLICK_TARGETS = '[data-quick-cart-close], .quick-cart__empty-state-cta a, .quick-cart__empty-state-cta button';

  function closeCart() {
    const wrap = document.querySelector(WRAP_SEL);
    const root = document.querySelector(ROOT_SEL);

    // Remove theme open classes (most themes toggle "active" on wrapper)
    if (wrap) wrap.classList.remove('active');
    if (root) root.classList.remove('active');

    // Try native theme close triggers if present
    const builtinClose = document.querySelector(
      `${ROOT_SEL} [data-modal-close], ${ROOT_SEL} .quick-cart__close-icon, ${ROOT_SEL} [aria-label="Close"]`
    );
    if (builtinClose) {
      try { builtinClose.click(); } catch (_) {}
    }

    // Ensure scroll-lock is released even if observer failed
    document.documentElement.classList.remove('wc-lock');
    document.body.classList.remove('wc-lock');

    // Optional: notify any listeners
    try { document.dispatchEvent(new CustomEvent('quick-cart:close')); } catch (_) {}
  }

  function onClick(e) {
    const el = e.target.closest(CLICK_TARGETS);
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    closeCart();
  }

  document.addEventListener('click', onClick, true);
})();
